import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faCalendarCheck } from "@fortawesome/free-solid-svg-icons";

function Horario() {
  return (
    <section className="py-5" id="features" style={{ backgroundColor: 'var(--background)' }}>
      <div className="container px-5 my-5">
        <div className="row gx-5 align-items-center">
          {/* Section Header */}
          <div className="col-lg-4 mb-5 mb-lg-0">
            <div className="animate-fade-in-up">
              <span className="text-uppercase fw-bold text-primary-color" style={{ letterSpacing: '2px', fontSize: '0.875rem' }}>
                Atención
              </span>
              <h2 className="section-title mt-2">
                Horario de Atención
              </h2>
              <p className="section-subtitle">
                Te esperamos de lunes a sábado para cuidar de tus mascotas
              </p>
            </div>
          </div>
          
          {/* Schedule Cards */}
          <div className="col-lg-8">
            <div className="row g-4">
              {/* Weekdays Card */}
              <div className="col-md-6">
                <div className="glass-card h-100 animate-fade-in-up animate-delay-100">
                  <div className="d-flex align-items-center mb-3">
                    <div 
                      className="rounded-circle d-flex align-items-center justify-content-center me-3"
                      style={{ 
                        width: '50px', 
                        height: '50px', 
                        background: 'var(--primary-gradient)',
                        color: 'white'
                      }}
                    >
                      <FontAwesomeIcon icon={faClock} size="lg" />
                    </div>
                    <h4 className="mb-0" style={{ fontFamily: 'var(--font-heading)' }}>
                      Lunes - Viernes
                    </h4>
                  </div>
                  
                  <div className="d-flex flex-column gap-2">
                    <div className="d-flex justify-content-between align-items-center py-2 px-3 rounded-3" style={{ background: 'var(--background-alt)' }}>
                      <span className="fw-medium">Mañana</span>
                      <span className="fw-bold text-primary-color">09:30 - 14:00</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2 px-3 rounded-3" style={{ background: 'var(--background-alt)' }}>
                      <span className="fw-medium">Tarde</span>
                      <span className="fw-bold text-primary-color">15:00 - 17:30</span>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Saturday Card */}
              <div className="col-md-6">
                <div className="glass-card h-100 animate-fade-in-up animate-delay-200">
                  <div className="d-flex align-items-center mb-3">
                    <div 
                      className="rounded-circle d-flex align-items-center justify-content-center me-3"
                      style={{ 
                        width: '50px', 
                        height: '50px', 
                        background: 'linear-gradient(135deg, var(--accent) 0%, var(--accent-light) 100%)',
                        color: 'white'
                      }}
                    >
                      <FontAwesomeIcon icon={faCalendarCheck} size="lg" />
                    </div>
                    <h4 className="mb-0" style={{ fontFamily: 'var(--font-heading)' }}>
                      Sábados
                    </h4>
                  </div>
                  
                  <div className="d-flex flex-column gap-2">
                    <div className="d-flex justify-content-between align-items-center py-2 px-3 rounded-3" style={{ background: 'var(--background-alt)' }}>
                      <span className="fw-medium">Mañana</span>
                      <span className="fw-bold text-accent">09:30 - 14:00</span>
                    </div>
                    <div className="py-2 px-3 rounded-3 text-center" style={{ background: 'var(--background-alt)', color: 'var(--text-muted)' }}>
                      <small>Domingos cerrado</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Horario;